import { render, staticRenderFns } from "./DoctorHour.vue?vue&type=template&id=72a3d1da"
import script from "./DoctorHour.vue?vue&type=script&lang=js"
export * from "./DoctorHour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports